<template>
  <div>
    <WsDialog
      v-model="isActive.dialog"
      ref="WsDialog"
      :title="title"
      @close="$_onClose"
    >
      <template v-slot:content>
        <ValidationObserver ref="form">
          <v-form
            ref="createForm"
            @submit.prevent
          >
            <v-row>
              <v-col
                v-for="(field, fieldKey) in fields"
                cols="12"
                :sm="field.sm ? field.sm : 12"
                :key="fieldKey"
              >
                <WsState
                  v-if="isActive.dialog"
                  :type="field.type"
                  :label="field.label"
                  :fields="field.fields"
                  :rules="field.rules"
                  :items="field.items"
                  :modelName="field.modelName"
                  :textKey="field.textKey"
                  :uploadUrl="field.uploadUrl"
                  :note="field.note"
                  :maxWidth="field.maxWidth"
                  :autofocus="field.autofocus"
                  :parent="field.parentKey"
                  :parentState="$_getParentState(fieldKey,fields)"
                  :requiredField="field.requiredField"
                  :displayLabel="field.displayLabel"
                  :excludeSelf="field.excludeSelf"
                  :maxlength="field.maxlength"
                  :value="filterState[fieldKey]"
                  :parentStateName="field.parentStateName"
                  :accept="field.accept"
                  :errorMessage="$_getErrorMessage(fieldKey)"
                  @input="$_onInput(fieldKey,$event)"
                />
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </template>
      <template v-slot:rightActions>
        <WsBtn
          outlined
          minWidth="100px"
          color="textSecondary"
          @click="$_onCancel"
        >取消</WsBtn>
        <WsBtn
          minWidth="100px"
          color="primary"
          :loading="isLoading.export"
          @click="$_onSubmit"
        >匯出</WsBtn>
      </template>
    </WsDialog>
  </div>
</template>

<script>
import S_download from '@/services/api/v1/download';

export default {
  props: {
    errorMessages: {
      type: Object,
    },
    title: {
      type: String,
      default: '匯出',
    },
    fields: {
      type: Object,
      default: () => {},
    },
    exportUrl: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
    },
  },
  data() {
    return {
      isActive: {
        dialog: false,
      },
      isLoading: {
        export: false,
      },
      filterState: {
      },
    }
  },
  methods: {
    $_onClose() {
      window.removeEventListener('keydown', this.$_keydownHandler);
    },
    async $_keydownHandler(event) {
      if (event.metaKey && event.key == 'Enter') await this.$_onSubmit();
    },
    async $_onSubmit() {
      const isValidate = await this.$refs.form.validate();
      if (!isValidate || !this.exportUrl) return;
      try {
        this.isLoading.export = true;
        const params = this.$_setParams();
        await S_download.xlsxDownload({
          url: this.exportUrl,
          params,
          fileName: this.fileName,
        });
        this.isLoading.export = false;
        this.close();
      } catch (error) {
        this.isLoading.export = false;
        alert(error);
      }
    },
    $_onCancel() {
      this.isActive.dialog = false;
      window.removeEventListener('keydown', this.$_keydownHandler);
      this.$_reset();
    },
    $_reset() {
      this.$_initFilterState();
    },
    $_getParentState(fieldKey, modedFields) {
      const field = this.$_CMS_getFieldByFieldKey(fieldKey, modedFields);
      if (!field || !field.parentKey || !field.requiredField) return null;
      return this.filterState[field.parentKey] || this.filterState[field.requiredField];
    },
    $_getErrorMessage(fieldKey) {
      if (!this.errorMessages) return null;
      return this.errorMessages[fieldKey] || null;
    },
    $_onInput(fieldKey, $event) {
      this.$set(this.filterState, fieldKey, $event);
    },
    open() {
      this.isActive.dialog = true;
      this.$_initFilterState();
    },
    close() {
      this.isActive.dialog = false;
      this.$_reset();
    },
    $_initFilterState() {
      const fieldDefaultValueList = {
        'select': '',
        'hasMany': [],
      }
      for (let key in this.fields) {
        this.$set(this.filterState, key, fieldDefaultValueList[this.fields[key].type] || '');
      }
    },
    $_setParams() {
      const typeList = {
        'object': (rawData) => Array.isArray(rawData) ? rawData.join(',') : null,
      };
      const params = {};
      for (let key in this.filterState) {
        const state = this.filterState[key];
        const type = typeof state;
        params[key] = typeList[type] ? typeList[type](state) : state;
      }
      return params;
    }
  }
}
</script>